import SupplierReport from "../Components/SupplierReport";
import DoctorReport from "../Components/DoctorReport";
import ItemReport from "../Components/ItemDetailReport";
import StockReport from "../Components/StockReport";
import DailySalesReport from "../Components/DailySalesReport";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PetDetailsReport from "../Components/PetDetailsReport";
import ReportDashboard from "../Components/ReportDashboard";
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import ShopSalesReport from "../Components/ShopSalesReport";
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import DailySalesRevenueReport from "../Components/DailySalesRevenueReport";
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';


export const ReportModules = [
    {
        id: 0,
        name: 'Performance insights',
        component: ReportDashboard,
        icon: <AnalyticsOutlinedIcon />
    },
    {
        id: 2,
        name: 'Shop sales',
        component: ShopSalesReport,
        icon: <StorefrontOutlinedIcon />
    },
    {
        id: 3,
        name: 'Daily revenue',
        component: DailySalesRevenueReport,
        icon: <BarChartOutlinedIcon />
    },
    {
        id: 4,
        name: 'Doctor report',
        component: DoctorReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 1,
        name: 'Supplier report',
        component: SupplierReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 5,
        name: 'Item Details report',
        component: ItemReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 6,
        name: 'Stock report',
        component: StockReport,
        icon: <ArticleOutlinedIcon />
    },
    {
        id: 7,
        name: 'Daily Sales report',
        component: DailySalesReport,
        icon: <ArticleOutlinedIcon />
    },
    // {
    //     id: 6,
    //     name: 'Pet Details report',
    //     component: PetDetailsReport,
    //     icon: <ArticleOutlinedIcon />
    // },

]
